import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Clock } from 'lucide-react';
import { WhatsappLogo } from '@phosphor-icons/react';

const Contact = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="contact-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-black/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Contacto
          </h1>
          <p className="text-brand-black/60 text-lg">
            Estamos aquí para ayudarte
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {/* Contact Methods */}
            <div>
              <h2 className="font-display text-xl md:text-2xl mb-6 text-brand-black">Canales de Atención</h2>

              <div className="space-y-6">
                {/* WhatsApp - Primary */}
                <a
                  href="https://wa.me/1234567890"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-4 p-4 bg-green-500/10 border border-green-500/30 rounded-lg hover:bg-green-500/20 transition-colors group"
                >
                  <div className="p-3 bg-green-500 rounded-full text-white">
                    <WhatsappLogo size={24} weight="fill" />
                  </div>
                  <div>
                    <h3 className="font-medium text-green-600 group-hover:text-green-500">WhatsApp</h3>
                    <p className="text-sm text-green-600/70">Respuesta rápida</p>
                    <p className="text-sm text-green-600 mt-1">+52 XXX XXX XXXX</p>
                  </div>
                </a>

                {/* Email */}
                <a
                  href="mailto:info@alphatica.com"
                  className="flex items-start gap-4 p-4 brand-card hybrid-glow rounded-lg hover:border-brand-cobalt/50 transition-colors group"
                >
                  <div className="p-3 bg-brand-cobalt rounded-full text-white">
                    <Mail size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium text-brand-black">Correo Electrónico</h3>
                    <p className="text-sm text-brand-black/60">Para consultas generales</p>
                    <p className="text-sm text-brand-cobalt mt-1">info@alphatica.com</p>
                  </div>
                </a>

                {/* Hours */}
                <div className="flex items-start gap-4 p-4 brand-card hybrid-glow rounded-lg">
                  <div className="p-3 bg-brand-petroleum rounded-full text-white">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium text-brand-black">Horario de Atención</h3>
                    <p className="text-sm text-brand-black/60 mt-1">Lunes a Viernes: 9:00 - 18:00</p>
                    <p className="text-sm text-brand-black/60">Sábados: 10:00 - 14:00</p>
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ Reference */}
            <div>
              <h2 className="font-display text-xl md:text-2xl mb-6 text-brand-black">¿Tienes dudas?</h2>

              <div className="brand-card hybrid-glow p-6 rounded-lg mb-6">
                <p className="text-brand-black/80 mb-4">
                  Antes de contactarnos, te invitamos a revisar nuestra sección de
                  Preguntas Frecuentes donde podrás encontrar respuestas a las consultas más comunes.
                </p>
                <Link
                  to="/faq"
                  className="inline-flex items-center gap-2 text-brand-cobalt hover:underline font-medium"
                >
                  Ver Preguntas Frecuentes →
                </Link>
              </div>

              <div className="brand-card hybrid-glow p-6 rounded-lg border border-brand-cobalt/30">
                <h3 className="font-display text-lg mb-2 text-brand-black">Seguimiento de Pedido</h3>
                <p className="text-brand-black/60 text-sm mb-4">
                  Si ya realizaste una compra y deseas conocer el estado de tu pedido,
                  contáctanos por WhatsApp con tu número de orden.
                </p>
                <a
                  href="https://wa.me/1234567890?text=Hola,%20quiero%20conocer%20el%20estado%20de%20mi%20pedido"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 brand-btn rounded"
                >
                  <WhatsappLogo size={18} weight="fill" />
                  Rastrear Pedido
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
